import React from 'react';

export default () => <svg width="10" height="16" fill="#930000" viewBox="0 0 10 16"><path d="M0 13.69l1.546 1.587 8.128-7.052L2.134 0 .279 1.447l5.97 6.778z"/></svg>;